import localeText from '@/locales/datagrid'
import FilterModelPro, {
    GridFilterItemPro,
    GridFilterModelPro,
} from '../utils/filterModelPro'
import { GridColDefPro } from '../utils/types'
import FilterPanelSelect from './PanelSelect'

export default function FieldColuna({
    columns = [],
    item,
    onFilterModelChange,
    className,
}: {
    columns: GridColDefPro[]
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    className?: string
}) {
    columns = columns.filter(f => f.filterable !== false)

    return (
        <FilterPanelSelect
            label={localeText.filterPanelColumn}
            options={columns.map(column => ({
                value: column.field,
                label: column.headerName,
            }))}
            value={item.columnField ?? ''}
            className={className}
            onValueChange={valor => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id
                            ? (() => {
                                  const defaultOperatorForColumn =
                                      FilterModelPro.getDefaultOperator(
                                          columns.find(c => c.field === valor)
                                              ?.type,
                                      )

                                  return {
                                      ...p,
                                      columnField: valor,
                                      operatorValue:
                                          defaultOperatorForColumn ??
                                          p.operatorValue,
                                  }
                              })()
                            : p,
                    ),
                }))
            }}
        />
    )
}
